import React from 'react';

import AppHero from '../components/home/hero';
import AppAbout from '../components/home/about';
import AppFeature from '../components/home/feature';
import AppTools from '../components/home/tools';
// import AppWorks from '../components/home/works';
import AppFaq from '../components/home/faq';
import AppPricing from '../components/home/pricing';
import AppContact from '../components/home/contact';
import WorkSteps from '../components/home/steps';

function AppHome() {
  return (
    <div className='main'>
      <AppHero key='appHero' />
      <AppAbout />
      <AppFeature />
      <AppTools />
      {/* <AppWorks/> */}
      <WorkSteps />
      <AppFaq />
      <AppPricing />
      <AppContact />
    </div>
  );
}

export default AppHome;
